import React, { useEffect, useRef, useState } from "react";

function SolicitudesComerciantes() {
  const [solicitudes, setSolicitudes] = useState([]);
  const [error, setError] = useState(null);
  const [filtro, setFiltro] = useState("");
  const filtroRef = useRef(null);
  const [mensajeNota, setMensajeNota] = useState(null);
  const [estadoFiltro, setEstadoFiltro] = useState("pendientes");
  const [mostrarSoloPendientes, setMostrarSoloPendientes] = useState(true);

  useEffect(() => {
    fetch("https://panelcomerciantes.lagora.chat/api/get_solicitudes.php")
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          const conEstados = data.solicitudes.map((s) => ({
            ...s,
            nota: s.nota || "",
            revisada: s.revisada ? "1" : "0",
            introducida: s.introducida ? "1" : "0",
            pago_confirmado: s.pago_confirmado ? "1" : "0",
            fecha_pago: s.fecha_pago || null,
            email_pago_enviado: s.email_pago_enviado ? "1" : "0",
            rechazada: s.rechazada ? "1" : "0"
          }));
          setSolicitudes(conEstados);
        } else {
          setError("No se pudieron cargar las solicitudes.");
        }
      })
      .catch(() => setError("Error al conectar con el servidor."));
  }, []);

  const marcarComoRevisada = async (id, valor = 1) => {
    try {
      const res = await fetch("https://panelcomerciantes.lagora.chat/api/marcar_revisada.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id, revisada: valor }),
      });

      const data = await res.json();
      if (data.success) {
        setSolicitudes((prev) =>
          prev.map((s) => (s.id === id ? { ...s, revisada: "1" } : s))
        );
      } else {
        alert("❌ Error: " + data.message);
      }
    } catch (error) {
      console.error("❌ Error al marcar como revisada:", error);
      alert("❌ Error al conectar con el servidor.");
    }
  };

  const marcarComoIntroducida = async (id, valor = 1) => {
    try {
      const res = await fetch("https://panelcomerciantes.lagora.chat/api/marcar_introducida.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id, introducida: valor })
      });

      const data = await res.json();
      if (data.success) {
        setSolicitudes((prev) =>
          prev.map((s) =>
            s.id === id ? { ...s, introducida: valor.toString(), fecha_introducida: valor === 1 ? new Date().toISOString() : null } : s
          )
        );
      } else {
        alert("❌ Error: " + data.message);
      }
    } catch (error) {
      console.error("❌ Error al marcar como introducida:", error);
    }
  };

  const actualizarNota = (id, texto) => {
    setSolicitudes((prev) =>
      prev.map((s) => (s.id === id ? { ...s, nota: texto } : s))
    );
  };

  const guardarNota = async (id, nota) => {
    try {
      await fetch("https://panelcomerciantes.lagora.chat/api/guardar_nota.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id, nota })
      });
      setMensajeNota("✅ Nota guardada correctamente.");
      setTimeout(() => setMensajeNota(null), 3000);
    } catch (error) {
      console.error("❌ Error al guardar la nota:", error);
    }
  };

  const marcarComoRechazada = async (id, valor = 1) => {
    const solicitud = solicitudes.find(s => s.id === id);

    try {
      const res = await fetch("https://panelcomerciantes.lagora.chat/api/marcar_rechazada.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id, rechazada: valor })
      });

      const data = await res.json();
      if (data.success) {
        setSolicitudes((prev) =>
          prev.map((s) => (s.id === id ? { ...s, rechazada: valor.toString() } : s))
        );

        if (valor === 1) {
          await fetch("https://panelcomerciantes.lagora.chat/api/enviar_email_rechazo.php", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ nombre_comercio: solicitud.nombre_comercio, email: solicitud.email })
          });
          alert("📨 Se ha enviado un email de rechazo al comerciante.");
        }
      } else {
        alert("❌ Error al marcar como rechazada: " + data.message);
      }
    } catch (err) {
      console.error("❌ Error al marcar como rechazada:", err);
    }
  };


  const solicitudesFiltradas = solicitudes.filter((s) => {
    const coincideFiltro =
      s.nombre_comercio.toLowerCase().includes(filtro.toLowerCase()) ||
      s.email.toLowerCase().includes(filtro.toLowerCase()) ||
      s.telefono.includes(filtro);

    if (!coincideFiltro) return false;
    if (estadoFiltro === "pendientes") return s.revisada !== "1" && s.rechazada !== "1";
  if (estadoFiltro === "revisadas") return s.revisada === "1" && s.introducida !== "1" && s.pago_confirmado !== "1" && s.rechazada !== "1";
  if (estadoFiltro === "pagadas") return s.pago_confirmado === "1" && s.introducida !== "1" && s.rechazada !== "1";
  if (estadoFiltro === "introducidas") return s.introducida === "1" && s.rechazada !== "1";
  if (estadoFiltro === "rechazadas") return s.rechazada === "1";
  return true;
});
  useEffect(() => {
    if (filtroRef.current) filtroRef.current.focus();
  }, [filtro]);

  const enviarEmailPago = async (nombre, email, id) => {
    const solicitud = solicitudes.find(s => s.id === id);
    if (solicitud.email_pago_enviado === "1") {
      alert("✉️ Ya se ha enviado un email de pago a este comerciante.");
      return;
    }

    try {
      const res = await fetch("https://panelcomerciantes.lagora.chat/api/crear_sesion_pago.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ nombre_comercio: nombre, email })
      });
      const data = await res.json();
      if (data.success && data.url) {
        await fetch("https://panelcomerciantes.lagora.chat/api/enviar_email_pago.php", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ nombre_comercio: nombre, email, url: data.url })
        });

        setSolicitudes((prev) =>
          prev.map((s) => (s.id === id ? { ...s, email_pago_enviado: "1" } : s))
        );
        alert("📨 Email de pago enviado correctamente.");
      } else {
        alert("❌ Error al generar el enlace de pago: " + data.message);
      }
    } catch (err) {
      alert("❌ Error de conexión al enviar email de pago.");
    }
  };

const handlePagoCompletado = async (nombre_comercio, email) => {
  alert("✅ Pago simulado completado. Marcando como introducida...");

  try {
    const res = await fetch("https://panelcomerciantes.lagora.chat/api/marcar_introducida.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ nombre_comercio, email }),
    });

    const data = await res.json();
    if (data.success) {
      alert("🔓 Solicitud marcada como introducida correctamente.");
    } else {
      alert("❌ Error al marcar como introducida: " + data.message);
    }
  } catch (err) {
    alert("❌ Error de red al intentar marcar como introducida.");
  }
};




return (
  <div className="App">
    <h1>Solicitudes de Comerciantes</h1>
    {error && <p style={{ color: "red" }}>{error}</p>}
    {mensajeNota && <p style={{ color: "green" }}>{mensajeNota}</p>}

    <div style={{ marginBottom: "1rem" }}>
      <input
        type="text"
        placeholder="Buscar por nombre, email o teléfono"
        value={filtro}
        onChange={(e) => setFiltro(e.target.value)}
        ref={filtroRef}
        style={{ padding: "0.5rem", width: "100%", marginBottom: "1rem" }}
      />
      <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap" }}>
        <label>
          <input
            type="radio"
            checked={estadoFiltro === "pendientes"}
            onChange={() => setEstadoFiltro("pendientes")}
          /> Pendientes
        </label>
        <label>
          <input
            type="radio"
            checked={estadoFiltro === "revisadas"}
            onChange={() => setEstadoFiltro("revisadas")}
          /> Revisadas no introducidas
        </label>
                <label style={{ marginRight: "1rem" }}>
          <input
            type="radio"
            name="filtro"
            checked={estadoFiltro === "pagadas"}
            onChange={() => setEstadoFiltro("pagadas")}
          /> Pagadas no introducidas
        </label>
        <label>
          <input
            type="radio"
            checked={estadoFiltro === "introducidas"}
            onChange={() => setEstadoFiltro("introducidas")}
          /> Introducidas en el sistema
        </label>
        <label style={{ marginRight: "1rem" }}>
  <input
    type="radio"
    name="filtro"
    checked={estadoFiltro === "rechazadas"}
    onChange={() => setEstadoFiltro("rechazadas")}
  /> Rechazadas
</label>

      </div>
    </div>

      {solicitudesFiltradas.length === 0 ? (
        <p>No hay solicitudes que mostrar.</p>
      ) : (
        solicitudesFiltradas.map((solicitud) => (
          <div
            key={solicitud.id}
            style={{
              border: "1px solid var(--marron-medio)",
              borderRadius: "10px",
              padding: "1rem",
              marginBottom: "1.5rem",
              backgroundColor:
                solicitud.introducida === "1"
                  ? "#e7f9ec"
                  : solicitud.pago_confirmado === "1"
                  ? "#fff8e6"
                  : solicitud.revisada === "1"
                  ? "#f0f0f0"
                  : "#fff",
              textAlign: "left",
              boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
              opacity: solicitud.revisada === "1" ? 0.9 : 1,
            }}
          >
          <h3 style={{ color: "var(--marron-oscuro)" }}>
            {solicitud.nombre_comercio}
          </h3>
          <p><strong>Email:</strong> {solicitud.email}</p>
          <p><strong>Teléfono:</strong> {solicitud.telefono}</p>
          <p><strong>Localidad:</strong> {solicitud.localidad}</p>
          <p><strong>Tipo de negocio:</strong> {solicitud.tipo_negocio}</p>
          {solicitud.fecha_revisada && (
            <p><strong>📅 Fecha revisión:</strong> {new Date(solicitud.fecha_revisada).toLocaleString()}</p>
          )}
{solicitud.fecha_pago && (
              <p style={{ color: "#4B3F2E", fontWeight: "bold" }}>
                💳 Pago confirmado el {new Date(solicitud.fecha_pago).toLocaleString()}
              </p>
            )}
            {solicitud.pago_confirmado === "1" && (
              <p style={{ color: "#4B3F2E", fontWeight: "bold", marginBottom: "0.5rem" }}>
                💳 El comerciante ha realizado el pago
              </p>
            )}

          {solicitud.fecha_introducida && (
            <p><strong>✅ Fecha introducción:</strong> {new Date(solicitud.fecha_introducida).toLocaleString()}</p>
          )}

<details style={{ marginTop: "10px" }}>
              <summary style={{ cursor: "pointer", fontWeight: "bold", color: "var(--marron-medio)" }}>
                Ver respuestas del formulario
              </summary>
              <ul style={{ marginTop: "0.5rem", paddingLeft: "1rem" }}>
                {solicitud.respuestas.map((r, index) => (
                  <li key={index}>
                    <strong>{r.pregunta}</strong><br />
                    {r.respuesta}
                  </li>
                ))}
              </ul>
            </details>

          <div style={{ marginTop: "1rem" }}>
            <label><strong>Notas:</strong></label>
            <textarea
              rows="3"
              style={{ width: "100%", marginTop: "0.5rem" }}
              placeholder="Escribe aquí tus observaciones o comentarios..."
              value={solicitud.nota}
              onChange={(e) => actualizarNota(solicitud.id, e.target.value)}
              onBlur={(e) => guardarNota(solicitud.id, e.target.value)}
            />
          </div>

          {solicitud.revisada !== "1" ? (
            <button
              onClick={() => marcarComoRevisada(solicitud.id)}
              style={{ marginTop: "0.8rem" }}
            >
              Marcar como revisada
            </button>
          ) : (
            <button
              onClick={() => marcarComoRevisada(solicitud.id, 0)}
              style={{ marginTop: "0.8rem", backgroundColor: "#ccc" }}
            >
              Desmarcar como revisada
            </button>
          )}

          {solicitud.revisada === "1" && solicitud.introducida !== "1" ? (
            <button
              onClick={() => marcarComoIntroducida(solicitud.id)}
              style={{ marginTop: "0.8rem" }}
            >
              Marcar como introducida
            </button>
          ) : solicitud.revisada === "1" && solicitud.introducida === "1" && (
            <button
              onClick={() => marcarComoIntroducida(solicitud.id, 0)}
              style={{ marginTop: "0.8rem", backgroundColor: "#ccc" }}
            >
              Desmarcar como introducida
            </button>
          )}
          {solicitud.rechazada !== "1" ? (
            <button onClick={() => marcarComoRechazada(solicitud.id)}>❌ Rechazar solicitud</button>
          ) : (
            <>
              <p style={{ color: "red", fontWeight: "bold" }}>🚫 Solicitud rechazada</p>
              <button onClick={() => marcarComoRechazada(solicitud.id, 0)}>↩️ Revertir rechazo</button>
            </>
          )}

            <button onClick={() => enviarEmailPago(solicitud.nombre_comercio, solicitud.email, solicitud.id)}>
            Enviar email de pago
          </button>
        </div>
      ))
    )}
  </div>
);
}

export default SolicitudesComerciantes;